import { render, staticRenderFns } from "./assignDialog.vue?vue&type=template&id=3336c979"
import script from "./assignDialog.vue?vue&type=script&lang=js"
export * from "./assignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports